import { gql, MutationHookOptions, useMutation } from '@apollo/client';

const MUTATION = gql`
  mutation createClient($input: CreateClientInput!) {
    createClient(input: $input) {
      id
    }
  }
`;

export type Variables = {
  readonly input: {
    readonly name: string;
  };
};

export type Response = {
  readonly createClient: {
    readonly id: string;
  };
};

export const useCreateClientMutation = (
  options: MutationHookOptions<Response, Variables>,
) => useMutation<Response, Variables>(MUTATION, options);
